import { api } from '@/api'

/**
 * @template T
 * @param {string} path
 * @param {{ updateMethod?: 'patch' | 'put' }} options
 * @returns {ResourceApi<T>}
 */
export const createResourceApi = (path, options = {}) => ({
  async index(config) {
    const res = await api.get(path, config)
    return res.data
  },
  async show(resourceId, config) {
    const res = await api.get(`${path}/${resourceId}`, config)
    return res.data
  },
  async store(resourceData, config) {
    const res = await api.post(path, resourceData, config)
    return res.data
  },
  async update(resourceId, resourceData, config) {
    const res = await api[options.updateMethod ?? 'put'](
      `${path}/${resourceId}`,
      resourceData,
      config
    )
    return res.data
  },
  async destroy(resourceId, config) {
    await api.delete(`${path}/${resourceId}`, config)
  }
})
